import abstractModel from '../../core/ShopModel';

const resource = 'retailers/pdf_templates';
const model = abstractModel(resource);

model.setDefault = (id) => model.post({}, { path: `${resource}/${id}/set_default` });

export default model;
